<template>
	<div class="fwd-cku-test__btns">
		<!-- 저장 -->
		<sf-button v-if="isButton_(scrId, 'CC') && showSaveBtn" line icon="file" :onClick="() => saveAction('save')">
			{{ getMessage_('QWCC001131') }}
		</sf-button>
		<!--  작성 -->
		<sf-button v-if="isButton_(scrId, 'CU') && showRegBtn" line icon="sub-menu-off" :onClick="() => saveAction('register')">
			{{ getMessage_('QWCC000056') }}
		</sf-button>
		<!--  재작성 -->
		<sf-button v-if="isButton_(scrId, 'CC') && showRenewBtn" line icon="sub-menu-off" :onClick="renew">
			{{ getMessage_('QWCC001417') }}
		</sf-button>
		<!--  성적서 -->
		<sf-button v-if="isButton_(scrId, 'CU') && showRepBtn" line :onClick="() => reportAction('')">
			{{ getMessage_('QWCC001381') }}
		</sf-button>
		<!--  불량tag -->
		<sf-button v-if="isButton_(scrId, 'CU') && showTagBtn" line :onClick="() => reportAction('tag')">
			{{ getMessage_('QWCC001405') }}
		</sf-button>
		<!-- 레포트 팝업 -->
		<report-popup ref="reportPopup" @Refresh="refresh" :scrId="scrId"></report-popup>
		<err-popup ref="errPopup" :scrId="scrId" @keepGoing="save"></err-popup>
	</div>
</template>

<script>
import * as Yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/fcku/FwdCkuStts/store/helpers';
import ReportPopup from '@qms/Components/popup/ReportPopup.vue';
import ErrPopup from './ErrPopup.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { ReportPopup, ErrPopup },
	methods: {
		...rootMethods,
		...serviceMethods,
		async renew() {
			try {
				this.schemaSave.validateSync(this.selectedRow);
				this.setPopupSearchParam_({ key: 'saveStatus', value: 'renew' });
				this.setPopupSearchParam_({ key: 'custCd', value: '' });
				await this.refresh();
				this.setPopupSearchParam_({ key: 'custYn', value: 'Y' });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.setPopupSearchParam_({ key: 'saveStatus', value: '' });
			}
		},
		saveAction(flag) {
			try {
				if (flag === 'register') {
					this.schemaSave.validateSync(this.selectedRow);
					this.validateTableList();
					this.checkDataConsistency();
				}
				if (this.okList.length == 0 && this.ngList.length == 0) {
					this.$sf_showMessage({
						type: 'confirm',
						icon: 'confirm',
						message: flag === 'save' ? this.getMessage_('QWCC001119') : this.getMessage_('QWCC001794'),
						buttons: [{ title: 'Ok', clickFn: () => this.save(flag) }]
					});
				} else {
					this.$refs.errPopup.open({ okList: this.okList, ngList: this.ngList, flag });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		async save(flag) {
			try {
				this.$sf_toggleLoading(true);
				this.setSelectedRow_({ key: 'saveStatus', value: flag });
				const { data } = await this.saveData_(this.getFormDatas_);
				const { code, messageCd } = data.header;
				if (code == 0 || code == 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
				}
				code === 0 && this.refresh();
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001402') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		/** 저장 후 새로고침 */
		async refresh() {
			this.$sf_toggleLoading(true);
			try {
				/**에러메세지 초기화 */
				this.setState_({ key: 'attentionList', value: [] });
				this.setState_({ key: 'okList', value: [] });
				this.setState_({ key: 'ngList', value: [] });

				await this.getPopupList_();
				this.setPopupSearchParam_({ key: 'ipnNos', value: this.selectedRow.ipnNos });
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		validateTableList() {
			for (const tableRow of this.resultList) {
				if (!tableRow.prvsRsltCd) {
					throw new Error(this.getMessage_('QWCC001990')); //표에 작성하지 않은 결과가 있습니다. 모든 결과를 입력해야 작성 완료됩니다.
				} else continue;
			}
		},
		checkDataConsistency() {
			const { powQltyCd, apenCkuCd, clfcStCd, cdcnStCd, partBloCd, partSrgCd } = this.selectedRow;
			const result = { powQltyCd, apenCd: apenCkuCd, clfcStCd, cdcnStCd, partBloCd, partSrgCd };
			const msgCds = {
				powQltyCd: 'QWCC001938',
				apenCd: 'QWCC001941',
				clfcStCd: 'QWCC001942',
				cdcnStCd: 'QWCC001943',
				partBloCd: 'QWCC001939',
				partSrgCd: 'QWCC001979'
			};
			const testCnt = { powQltyCd: 0, apenCd: 0, clfcStCd: 0, cdcnStCd: 0, partBloCd: 0, partSrgCd: 0 }; //대구분별 총 테스트 개수
			const cnt = { powQltyCd: 0, apenCd: 0, clfcStCd: 0, cdcnStCd: 0, partBloCd: 0, partSrgCd: 0 }; //대구분별 총 ng 개수

			for (const tableRow of this.resultList) {
				if (tableRow.ckuLgrpCd === 'PHTG') continue;
				testCnt[_.camelCase(tableRow.ckuLgrpCd) + 'Cd']++;
				if (tableRow.prvsRsltCd == 'NG') {
					cnt[_.camelCase(tableRow.ckuLgrpCd) + 'Cd']++;
				} else continue;
			}

			/**에러메세지 초기화 */
			this.setState_({ key: 'attentionList', value: [] });
			this.setState_({ key: 'okList', value: [] });
			this.setState_({ key: 'ngList', value: [] });

			for (const [key, value] of Object.entries(cnt)) {
				const lowerValue = _.snakeCase(key.substr(0, key.length - 2));
				if (result[key] == 'NG' && testCnt[key] && value == 0) {
					!this.ngList.includes(msgCds[key]) && this.pushErrorList_({ key: 'ngList', value: msgCds[key] });
					this.pushAttentionList_(lowerValue.toUpperCase());
				}
				if (result[key] == 'OK' && testCnt[key] && testCnt[key] == value) {
					!this.okList.includes(msgCds[key]) && this.pushErrorList_({ key: 'okList', value: msgCds[key] });
					this.pushAttentionList_(lowerValue.toUpperCase());
				}
			}
		},
		//레포트 출력
		async reportAction(params) {
			const { feTarget, ubiTarget } = await this.fetchList_('Y');
			const langCd = this.langCd;
			let sendParams = { ubiTarget };
			if (params === 'tag') {
				//불량보고서 출력
				this.setSelectedRow_({ key: 'oputStCd', value: '20' }); //20 : 불량tag
				this.updateOputSt_(); //비동기적으로 처리할 필요 x, 사용자의 사용감을 위해서 리포트를 먼저 띄우고 순서와 상관 없이 처리되어도 됨.
				let badList = 'badList#"';
				const powQltyList = _.filter(this.resultList, result => {
					return result.ckuLgrpCd === 'POW_QLTY' && result.prvsRsltCd === 'NG' ? true : false;
				});
				const partBloList = _.filter(this.resultList, result => {
					return result.ckuLgrpCd === 'PART_BLO' && result.prvsRsltCd === 'NG' ? true : false;
				});
				const cnt = Math.max(powQltyList.length, partBloList.length);
				for (let idx = 0; idx < Math.max(cnt, 1); idx++) {
					badList += (powQltyList[idx]?.ipnPrvsSbc || ' - ') + '^t';
					badList += (partBloList[idx]?.ipnPrvsSbc || ' - ') + '^n';
				}

				badList = badList.substring(0, badList.length - 2);

				sendParams = {
					...sendParams,
					jrfName: `ngReport_${langCd}.jrf`,
					streamdata:
						badList +
						'"#tag#"' +
						(this.selectedRow.pmcNo || ' - ') +
						'^t' +
						(this.selectedRow.tymaNm || ' - ') +
						'^t' +
						(this.selectedRow.pprrDt || '  ') +
						'^t' +
						(this.selectedRow.pprrNm || ' - ') +
						'^t' +
						(this.selectedRow.powQltyCd || ' - ') +
						'^t' +
						(this.selectedRow.partBloCd || ' - ') +
						'^t' +
						(this.selectedRow.partSrgCd || ' - ') +
						'^t' +
						(this.selectedRow.apenCkuCd || ' - ') +
						'^t' +
						(this.selectedRow.clfcStCd || ' - ') +
						'^t' +
						(this.selectedRow.cdcnStCd || ' - ') +
						'^t' +
						(this.selectedRow.badSbc || ' - ') +
						'"'
				};
			} else {
				//성적서 출력
				this.setSelectedRow_({ key: 'oputStCd', value: '30' }); //30 : 성적서발행
				this.updateOputSt_(); //비동기적으로 처리할 필요 x, 사용자의 사용감을 위해서 리포트를 먼저 띄우고 순서와 상관 없이 처리되어도 됨.
				let listData = '"#list#"';
				let imgs = [];
				for (const result of this.okReport) {
					if (result.useYn == 'N') continue;
					//^t : column 구분자 ^n : row 구분자
					listData += (result.lgrpNm || ' - ') + '^t';
					listData += (result.sgrpNm || ' - ') + '^t';
					listData += (result.ipnPrvsSbc || ' - ') + '^t';
					listData += (result.minVal || ' - ') + '^t';
					listData += (result.maxVal || ' - ') + '^t';
					listData += (result.utmNm || ' - ') + '^t';
					listData += (result.ipnWayNm || ' - ') + '^t';
					listData += (result.spcRslt || ' - ') + '^t';
					listData += (result.prvsRsltNm || ' - ') + '^n';

					if (result.fwdImgFileDb) {
						const { uploadPath, saveFileName } = result.fwdImgFileDb;
						if (uploadPath && saveFileName) {
							const idx = uploadPath.lastIndexOf('attachment') + 'attachment'.length;
							const imgPath = feTarget + 'fimages' + uploadPath.substring(idx, uploadPath.length) + '/' + saveFileName;
							imgs.push(imgPath.replaceAll('\\', '/')); //역슬러시는 pdf 또는 인쇄물에서서 안나와서 바꿔주는 작업 필요
						}
					}
				}
				listData = listData.substring(0, listData.length - 2) + '"';
				
				sendParams = {
					...sendParams,
					jrfName: `okReport_${langCd}.jrf`,
					streamdata:
						'master#"' +
						(this.selectedRow.pmcNo || ' - ') +
						'^t' +
						(this.selectedRow.custProdNo || ' - ') +
						'^t' +
						(this.selectedRow.custCd || ' - ') +
						'^t' +
						(this.selectedRow.custNm || '  ') +
						'^t' +
						(this.selectedRow.htwoCd || ' - ') +
						'^t' +
						(this.selectedRow.htwoNm || ' - ') +
						'^t' +
						(this.selectedRow.prdtDd || ' - ') +
						'^t' +
						'1' +
						'^t' +
						(this.selectedRow.jgmtRsltNm || ' - ') +
						'^t' +
						(this.selectedRow.pprrNm || ' - ') +
						'^t' +
						(this.selectedRow.rvwrNm || ' - ') +
						'^t' +
						(this.selectedRow.cserNm || ' - ') +
						'^t' +
						(this.selectedRow.pprrDt || ' - ') +
						'^t' +
						(imgs[0] || '') +
						'^t' +
						(imgs[1] || '') +
						'^t' +
						(imgs[2] || '') +
						'^t' +
						(imgs[3] || '') +
						listData
				};
			}
			this.$refs.reportPopup.openWindowReport(sendParams);
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		showSaveBtn() {
			return this.popupSearchParams.pmcNo && this.popupSearchParams.ipnNos && !this.selectedRow.csetDd;
		},
		showRegBtn() {
			return this.showSaveBtn;
		},
		showRenewBtn() {
			return this.selectedRow.csetDd && this.selectedRow.rvwrId && this.selectedRow.cserId;
		},
		showChangeBtn() {
			return this.hasChanged_ && this.showRenewBtn;
		},
		showRepBtn() {
			return this.showRenewBtn && this.selectedRow.jgmtRsltCd === 'OK' && this.selectedRow.oputStCd == '10'; //10:미출력
		},
		showTagBtn() {
			return this.showRenewBtn && this.selectedRow.jgmtRsltCd !== 'OK'; //불량태그는 항시 보여야 한다. 작성 이후
		},
		schemaSave() {
			return Yup.object().shape({
				rvwrId: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001092')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001092')])),
				cserId: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000011')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000011')])),
				jgmtRsltCd: Yup.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000008')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000008')]))
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.fwd-cku-test__btns {
	height: 43px;
}
</style>
